import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { WestnetzSidenavService } from '../../service/common/westnetz-sidenav/westnetz-sidenav.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ImportRegelService } from '../../service/import-regel/import-regel.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'redispatch-settings-netzzuordnung-import-detail',
    templateUrl: './settings-netzzuordnung-import-detail.component.html',
    styleUrls: [
        './settings-netzzuordnung-import-detail.component.scss',
    ],
    standalone: false,
})
export class SettingsNetzzuordnungImportDetailComponent implements OnInit, OnDestroy {

    public importRegelDetailForm: UntypedFormGroup;
    public westnetzSidenavService = inject(WestnetzSidenavService);
    private $destroy = new Subject<void>();
    private formBuilder = inject(UntypedFormBuilder);
    private importRegelService = inject(ImportRegelService);
    private changeDetectorRef = inject(ChangeDetectorRef);

    constructor() {
        this.importRegelDetailForm = this.formBuilder.group({
            maxZuordnungsAenderungen: [
                0,
                [
                    Validators.required,
                ],
            ],
            maxZuordnungsAenderungenProStadtwerk: [
                0,
                [
                    Validators.required,
                ],
            ],
            netzverknuepfungsgrenzwert: [
                0,
                [
                    Validators.required,
                ],
            ],
            limitAenderungLeistung: [
                0,
                [
                    Validators.required,
                ],
            ],
        });
    }

    ngOnInit(): void {
        this.importRegelService.getImportRegeln()
            .pipe(
                takeUntil(this.$destroy),
            ).subscribe(next => {
                this.importRegelDetailForm.patchValue(next);
                this.changeDetectorRef.markForCheck();
            });
    }

    ngOnDestroy(): void {
        this.$destroy.next();
    }

    public saveImportRegel(): void {
        if (!this.importRegelDetailForm.valid) {
            return;
        }
        const value = this.importRegelDetailForm.value;
        this.importRegelService.updateImportRegeln(value).subscribe(_next => {
            this.westnetzSidenavService.closeRightnav();
        });
    }
}
